import { render, staticRenderFns } from "./TableSharedFieldsContainer.vue?vue&type=template&id=49da5dbf&scoped=true&"
import script from "./TableSharedFieldsContainer.vue?vue&type=script&lang=js&"
export * from "./TableSharedFieldsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TableSharedFieldsContainer.vue?vue&type=style&index=0&id=49da5dbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49da5dbf",
  null
  
)

export default component.exports